import { useEffect, useRef } from "react";

/** Calls `onOutside` when a mousedown lands outside the returned ref. */
const useOutsideClick = (active, onOutside) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!active) return undefined;

    const handler = (event) => {
      if (ref.current && !ref.current.contains(event.target)) onOutside();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [active, onOutside]);

  return ref;
};

export default useOutsideClick;
